
import { apiRequest, SUPABASE_URL } from './apiUtils';
import { config } from '@/config';

interface PasswordResetResponse {
  success: boolean;
  message?: string;
}

export const authApi = {
  /**
   * Request a password reset email to be sent to the provided email address.
   */
  requestPasswordReset: async (email: string): Promise<PasswordResetResponse> => {
    try {
      // Get the current origin or use the configured client URL
      const origin = window.location.origin || config.CLIENT_URL;
      
      // Set the redirect URL to the set-password page
      const redirectUrl = `${origin}/auth/set-password`;
      
      console.log("Requesting password reset with redirectUrl:", redirectUrl);
      
      const response = await apiRequest<PasswordResetResponse>(`${SUPABASE_URL}/password-reset`, {
        method: 'POST',
        body: {
          email,
          redirectTo: redirectUrl
        }
      });
      
      console.log('Password reset response:', response);
      return response;
    } catch (error: any) {
      console.error('Password reset request failed:', error);
      throw new Error(error.message || 'Failed to request password reset');
    }
  }
};
